import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import {setPageInfo} from "../store/actions/pagesinfo";
import {pathList} from "../router";

const pathName = JSON.parse(JSON.stringify(pathList));

@connect(state => ({
	pages: state.pages,
	game: state.game && state.game.game || {},
}), dispatch => ({
	setPageInfo: bindActionCreators(setPageInfo, dispatch),
}))
class PageInfo extends React.Component {

	directPageNames = 'home,schedule,packages,guide,privacy,tos,faq,search,devicereg,events,archives,channels';

	sendPageTracker(pageName, seoname)
	{

		let nltrackPath = '';
		if (this.directPageNames.split(',').indexOf(pageName) !== -1)
		{
			nltrackPath = '/' + pageName;
		}
		else if (pageName === 'category' || pageName === 'categories')
		{
			nltrackPath = '/category' + seoname
		}
		else if (pageName === 'video' || pageName === 'event')
		{
			nltrackPath = '/video' + seoname
		}
		else if (pageName === 'channel')
		{
			nltrackPath = '/channel/' + seoname
		}
		else if (pageName === 'game')
		{
			nltrackPath = '/game/' + seoname
		}
		else
		{
			nltrackPath = '/page/' + pageName;
		}
		if (!window.NLTracker) return;
		NLTracker.trackPage(nltrackPath);
	}

	componentDidUpdate(prevProps)
	{
		const {location, setPageInfo} = this.props;
		if (location.pathname !== prevProps.location.pathname)
		{
			if (!(/^\/game\//.test(location.pathname)))
			{
				if (/^\/channel\//.test(location.pathname))
				{
					setPageInfo(pathName['/channel/:seoname'].toLowerCase());
					this.sendPageTracker(location.pathname.replace('/channel/', ''))
				}
				else
				{
					setPageInfo(pathName[location.pathname].toLowerCase());
					this.sendPageTracker(pathName[location.pathname].toLowerCase())
				}
			}
			window.scrollTo(0, 0);
		}
	}

	componentWillReceiveProps(nextProps)
	{
		const {location} = nextProps;

		if (/^\/game\//.test(location.pathname) && this.props.game.seoName !== nextProps.game.seoName && nextProps.seoName !== '')
		{
			this.props.setPageInfo(pathName['/game/:seoname'].toLowerCase(), nextProps.game);
			this.sendPageTracker(location.pathname.replace('/game/', ''))
		}
	}

	render()
	{
		return null
	}

}
export default withRouter(PageInfo);